import React from 'react';

const PrettyJsonString = React.memo(({ data }: any) => {
  try {
    const json = JSON.parse(data);
    return (
      <div style={{ fontFamily: 'monospace' }}>
        <pre>{JSON.stringify(json, null, 2)}</pre>
      </div>
    );
  } catch (error) {
    return data || '-';
  }
});

export default PrettyJsonString;
